export const ReportsPaths = {
  ROOT: '/reports',
  DISTRIBUTORS: {
    ROOT: '/reports/distributors',
  },
} as const;
